import React from "react";
import Button from "./Button";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="auth-page">
          <div className="card" style={{ width: 420, textAlign: "center" }}>
            <div className="danger-icon">!</div>
            <h2 className="h2">Something went wrong</h2>
            <p className="muted">An unexpected error occurred.</p>
            <Button variant="secondary" onClick={() => window.history.back()}>
              Go Back
            </Button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
